module.exports = __webpack_public_path__ + "static/media/news2.56f636cb.jpg";